export enum ProductSize {
    SMALL = "SMALL",
    NORMAL = "NORMAL",
    LARGE = "LARGE",
    SET = "SET",
}

export enum ProductVolume {
    HALF = 0.5,
    ONE = 1,
    ONE_POINT_TWO = 1.2,
    ONE_POINT_FIVE = 1.5,
    TWO = 2,
}

export enum ProductWeight {
    G300 = 300,
    G500 = 500,
    KG1 = 1000,
    KG2_5 = 2500,
}

export enum ProductStatus {
    PAUSE = "PAUSE",
    PROCESS = "PROCESS",
    DELETED = "DELETED",
}

export enum ProductCollection {
    FISH = "FISH",
    BIRD = "BIRD",
    CAT = "CAT",
    DOG = "DOG",
    GADGETS = "GADGETS",
}